import Config from '@skin_config';
import { t } from '@common/helpers/translator';
import ToastWrapper from '@common/helpers/toastWrapper';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { getTicketsDispatcher, getTicketsState } from '@tickets/store/context';
import { browserHistory } from '@common/helpers/browserHistory';
import { POPUPS } from '@common/constants/popups';
import { checkIsTicketAlreadyAdded, getAllTickets, TicketHandlers } from '@tickets/helpers/addTicketByType';
import { getTicketType, isOneTimeLoginTicket } from '@tickets/helpers/type';
import { removeBarcodeDuplicates } from '@tickets/helpers/barcode';
import { LoyalCard, AdminUserCommands, CheckOneTimeLogin } from '../actions/terminal';
import { store } from '../index/terminalApp';
import { getTickets } from '@tickets/helpers/addBarcode';
import { handleTicketError } from "@tickets/helpers/error";

import { BetStateEnum } from '../constants/enums/betState';
import { fetchRequest } from './util/requestMiddleware';
import { getPopupDispatchers } from '../contexts/popup';
import { findByBookId } from './bookingCheck';
import PaymentsService from '../services/payments';

const TICKET_BARCODE_LENGTH = 11;

export const getCasinoBetsInfo = async (transIds) =>
  fetchRequest(
    Config.casino.middlewareUrl,
    `api/tickets/GetTicketInfoByTransactionIdsTokenAuth?token=${Config.casino.middlewareAuthToken}`,
    "POST",
    { body: transIds }
  );

export const processBarcode = async (barcode) => {
  const state = store.getState();
  let result = removeBarcodeDuplicates(barcode);

  const { openPopup, closePopup } = getPopupDispatchers();

  if (Config.main.disableCheckTicketAfterLogin && state.user.loggedIn) return null;

  if (isOneTimeLoginTicket(barcode)) {
    return store.dispatch(CheckOneTimeLogin(barcode));
  }

  const ticketType = getTicketType(result);

  if (result.length >= TICKET_BARCODE_LENGTH) {
    const sportList = getTicketsState();
    const setSportList = getTicketsDispatcher();

    if (checkIsTicketAlreadyAdded(sportList, result)) {
      browserHistory.push("/tickets");
      ToastWrapper("error", "barcode already added");
      return;
    }
    if (result.length < 8 || result.length >= 21) {
      ToastWrapper("error", "Bet not found");
      return;
    }

    if (!ticketType) {
      ToastWrapper("error", "Wrong barcode");
      return;
    }

    // const data = await TicketHandlers[ticketType](result);
    const data = await getTickets(ticketType, result);

    if (!data) return;

    if (data?.ticketError?.error) {
      handleTicketError(data);
      ToastWrapper("error", data.ticketError.errorText);
      return;
    }

    setSportList({
      ...sportList,
      [ticketType]: [
        ...(Config.tickets.enableMultipleTickets ? sportList[ticketType] : []),
        {
          ...data,
          ticketType,
          originalBarcode: result,
        },
      ],
    });

    const isTicketsPage = window.location.pathname === '/tickets';
    const noTickets = getAllTickets(sportList).length === 0;

    if ((noTickets && !isTicketsPage) || !Config.tickets.enableMultipleTickets) {
      openPopup(POPUPS.TICKET_DETAILS_POPUP, { ticketType });
    } else if (!isTicketsPage) {
      browserHistory.push('/tickets');
    }

    return;
  }

  if (state.terminal.isLoyalCardInputActive && result.length < 9) {
    if (!state.terminal.loyalCard?.result) store.dispatch(LoyalCard({ result }));
    window.barcodeBuffer = [];
    closePopup();
    return;
  }

  if (isNaN(result)) {
    ToastWrapper('error', 'Bet not found');
    window.barcodeBuffer = [];
    return;
  }

  if (result.length >= 5 && result.length <= 8) {
    findByBookId(result);
    return;
  }

  ToastWrapper("error", "Wrong barcode");

  // result = result.replace(/^\s+|\s+$/g, "");

  // let fullTicket;
  // if (result.length === 20 && result[0] === "1") {
  //   fullTicket = result;
  //   result = result.slice(1, result.length);
  //   result = result.slice(0, result.length - 7);
  //   result = Number(result);

  //   // TODO make request for only betId now it is betId + 0
  //   result *= 10;
  // }
  // // TODO With Khikar
  // if ((result.length === 12 || result.length === 13 || result.length === 11) && Config.tickets.oldTicketsRestriction) {
  //   return openPopup(POPUPS.ERROR_POPUP, { errorMessage: "Wrong Ticket." });
  // }
  // result = String(result);

  // let command = "check_terminal_bet_ticket";
  // const str = String(parseInt(result));
  // const params = {
  //   bar_code: result,
  //   is_with_cashout: true,
  //   token: state.terminal?.authData.token,
  // };
  // if (isCashOutTicket(str)) {
  //   command = "check_terminal_tito_document";
  //   delete params.bar_code;
  //   delete params.is_with_cashout;

  //   if (result.slice(0, 2) == "99" || result.slice(0, 2) == "98") {
  //     params.doc_id = parseInt(result.slice(1, result.length - 1));
  //   } else {
  //     params.doc_id = parseInt(result.slice(1, result.length));
  //   }
  // }

  // swarmRequest(params, command)
  //   .then((data) => {
  //     const barcodeResult = getBarcodeResultForSpring(data, str, fullTicket);
  //     if (barcodeResult.data) {
  //       if (barcodeResult.data.error) {
  //         if (Config.enableMultipleWinsPopup) {
  //           // store.dispatch(OpenPopup('multipleTicketsPopup', barcodeResult));
  //           window.barcodeBuffer = [];
  //           return;
  //         }
  //         throwTicketError(barcodeResult.data);
  //         window.barcodeBuffer = [];
  //         return;
  //       }
  //       // enableMultipleWinsPopup
  //       if (!barcodeResult.data.cashout && !Config.enableMultipleWinsPopup) {
  //         // store.dispatch(TicketIn(barcodeResult));
  //       } else if (!barcodeResult.data.cashout && Config.enableMultipleWinsPopup) {
  //         // store.dispatch(OpenPopup('multipleTicketsPopup', barcodeResult));
  //       } else if (Config.enableMultipleWinsPopup) {
  //         // store.dispatch(OpenPopup('multipleTicketsPopup', barcodeResult));
  //       } else {
  //         openPopup(POPUPS.CASH_IN, { data: barcodeResult });
  //       }
  //     }
  //     window.barcodeBuffer = [];
  //   })
  //   .catch(() => {
  //     window.barcodeBuffer = [];
  //   });

  // const enableTitoArgs = (details) => (details ? details.bo_payment || +details.amount > 0 : null); // if it is cashout ticket or bet ticket that has WinAmount
  // const getStatusText = (amount, status) => {
  //   const { currency } = JSON.parse(sessionStorage.getItem("authData"));
  //   const symbol = Config.currencySymbol[currency];
  //   /* TODO add getStatusText in variable */
  //   const statusTexts = {
  //     1: "Your bet is still pending. Please try again later.",
  //     3: "Unlucky! Your bet is lost.",
  //     2() {
  //       return `${t("Your bet has been canceled. Returned amount is")} ${Config.main.useCurrencySymbol ? symbol + amount : `${amount} ${currency}`
  //         }`;
  //     },
  //     4() {
  //       return `${t("Well done! You’ve just won")} ${Config.main.useCurrencySymbol ? symbol + amount : `${amount} ${currency}`
  //         }`;
  //     },
  //     5() {
  //       return `${t("Bet has been cashouted. Return amount is")} ${Config.main.useCurrencySymbol ? symbol + amount : `${amount} ${currency}`
  //         }`;
  //     },
  //     cashout() {
  //       return t("Your cashout amount is ") + symbol + amount;
  //     },
  //   };
  //   return typeof statusTexts[status] === "function" ? statusTexts[status]() : statusTexts[status];
  // };

  // let getBarcodeResultForSpring = (details, barcode, fullTicket) => {
  //   let data;
  //   let ticketError;

  //   const ticketErrMap = (error, paidDate) => {
  //     const map = {
  //       TerminalTicketAlreadyPaid: "Voucher is already exchanged",
  //       TerminalTicketNotFound: "Terminal ticket not found",
  //       BetNotFoundError: "Bet not found",
  //       alreadyPaid: "This ticket is already paid",
  //       "The bet is not found": "Bet not found",
  //       WrongInputParameters: "Wrong ticketBarcode parameters",
  //       NotAuthorized: "Terminal ticket not found",
  //       InternalError: "Bet not found wefwff",
  //       "Client currency mismatch": "Bet not found",
  //       "Error processing your request": "Bet not found",
  //       PartnerMismatch: "Bet not found",
  //       "Not allowed": "The bet was placed in another location",
  //     };

  //     if (paidDate) {
  //       return t(map.alreadyPaid);
  //     }
  //     return t(map[error]);
  //   };

  //   if (isCashOutTicket(barcode)) {
  //     ticketError = ticketErrMap(details.data) || (details.status_code !== 0 && details.data);
  //     if (ticketError) {
  //       data = {
  //         cashout: true,
  //         error: details.status_code ? details.status_code : details.code,
  //         errorText: ticketError,
  //       };
  //     } else {
  //       data = {
  //         cashout: true,
  //         bo_payment: true,
  //         amount: details.data.amount,
  //         barcode: details.data.document_id,
  //         created: details.data.date,
  //         // status: ticketErrMap(details.status_code),
  //         status: ticketErrMap(details.status_code),
  //         data: ticketErrMap(details.data),
  //       };
  //     }
  //   } else {
  //     ticketError = ticketErrMap(details.data, details.data.paid_date) || (details.status_code !== 0 && details.data);
  //     if (ticketError) {
  //       data = {
  //         cashout: false,
  //         error: details.data.paid_date ? 1 : details.status_code ? details.status_code : details.code,
  //         errorText: ticketError,
  //       };
  //     } else {
  //       let estimatedReturns = details.data.possible_win; // details.data.tax_amount ? (details.data.possible_win - details.data.tax_amount).toFixed(2) : details.data.possible_win;
  //       if (details.data.win_amount || details.data.state_id === 4 || details.data.state_id === 5) {
  //         estimatedReturns = details.data.tax_amount
  //           ? (details.data.win_amount - details.data.tax_amount).toFixed(2)
  //           : details.data.win_amount;
  //       } else {
  //         estimatedReturns = details.data.possible_tax_amount
  //           ? (details.data.possible_win - details.data.possible_tax_amount).toFixed(2)
  //           : details.data.possible_win;
  //       }

  //       data = {
  //         cashout: false,
  //         bo_payment: false,
  //         amount: details.data.win_amount,
  //         betAmount: details.data.amount,
  //         betshop_id: details.data.betshop_id,
  //         possibleWin: details.data.possible_win,
  //         possible_tax_amount: details.data.possible_tax_amount,
  //         tax_amount: details.data.tax_amount,
  //         price: details.data.price,
  //         sportBet: true,
  //         system_min_count: details.data.system_min_count,
  //         selectionCount: details.data.selection_list?.length || 1,
  //         created: details.data.created,
  //         betType: details.data.type_name,
  //         betTypeId: details.data.type_id,
  //         bet_state_id: details.data.state_id,
  //         bet_state_name: details.data.state_name,
  //         win_amount: details.data.win_amount,
  //         barcode: fullTicket || details.data.bar_code || details.data.barcode,
  //         status: details.data.state_id,
  //         cashout_amount: details.data.cashout_amount,
  //         paid_date: details.data.paid_date,
  //         predefined_multiple_id: details.data.predefined_multiple_id,
  //         betBuilderDetails: details.data.bet_details?.description,
  //         events: {
  //           event: ((events) => {
  //             const evs = [];
  //             for (const key in events) {
  //               if (events.hasOwnProperty(key)) {
  //                 const e = events[key];
  //                 e.__index__ = key;
  //                 e.coeficient = e.price;
  //                 e.game_name = e.match_name;
  //                 e.start_date_time = e.start_time;
  //                 e.event_name = `${e.display_market_name}-${e.display_selection_name}`;
  //                 e.outcome = e.state;
  //                 evs.push(e);
  //               }
  //             }
  //             return evs;
  //           })(details.data.selection_list),
  //         },
  //         statusText: getStatusText(estimatedReturns, details.data.state_id),
  //       };
  //     }
  //   }
  //   return {
  //     data,
  //     enableTitoArgs: enableTitoArgs(data),
  //   };
  // };
};

const throwTicketError = (text) => {
  ToastWrapper("error", text);

  // isMultpleTicketsPopupOpen()
  //     ? store.dispatch(OpenPopup('multipleTicketsPopup', { data: { error: true, errorText: t(text) } }))
  //     : store.dispatch(TerminalError(t(text)));
};

// const isMultpleTicketsPopupOpen = () => store.getState().uiState.popup === 'multipleTicketsPopup';

const isCashOutTicket = (str) => str && str.length > 12 && str.charAt(0) === "9";
const isCasinoTicket = (str) => str && str.length > 13 && str.charAt(0) === "2";
